<template>
  <div class="page">
    <!--Title/Actions-->
    <div class="page-header flex-shrink-0 mb-3 bg-white border-bottom">
      <div class="container-fluid d-flex justify-content-between align-items-center px-md-4 px-3">
        <h3 class="mb-0"><i class="fas fa-file"></i>&nbsp;Document Types</h3>
        <b-form inline>
          <b-form-checkbox class="mr-3 d-md-block d-none" v-model="showArchived" switch @input="toggleShowArchived"><span>Show
              Archived</span></b-form-checkbox>
          <b-btn @click="showDocumentTypeModal(null)" class="btn btn-success"><i class="fas fa-plus mr-1"></i>Document
            Type</b-btn>
        </b-form>
      </div>
    </div>

    <!--Search-->
    <div class="container-fluid px-md-4 px-3 py-3 bg-white border-bottom mb-3">
      <div class="row no-gutters">
        <div class="col-lg-4 col-md-6">
          <b-input-group>
            <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
          </b-input-group>
        </div>
        <b-button :disabled="!filter" variant="link" @click="filter = ''">Clear</b-button>
      </div>
    </div>

    <!--Table-->
    <div class="container-fluid flex-grow-1 overflow-auto px-md-4 px-3">
      <div v-if="documentTypes">
        <b-table id="document-types-table" bordered class="mb-5 rg-table" :items="documentTypeProvider"
          :fields="documentTypeTableData.fields" no-local-filtering :filter="filter" no-local-sorting
          :sortDesc.sync="sortDesc" :busy.sync="isBusy">
          <template v-slot:cell(name)="data">
            <div class="emphasis">
              {{ data.item.name }}
            </div>
          </template>
          <template v-slot:cell(status)="data">
            <div class="emphasis">
              {{ data.item.active ? "Active" : "Inactive" }}
            </div>
          </template>
          <template v-slot:cell(isArchived)="data">
            <b-icon-archive v-if="data.item.isArchived" />
          </template>
          <template v-slot:cell(id)="data">
            <b-btn title="Edit Document Type" @click="showDocumentTypeModal(data.item.id)" variant="link"><i
                class="fas fa-edit"></i></b-btn>
          </template>
        </b-table>
      </div>
    </div>
    <!--Modal-->
    <b-modal v-model="modalOpen" title="Add/Edit Document Type" no-close-on-backdrop no-close-on-esc hide-header-close>
      <div v-if="documentTypeForEdit">
        <b-form>
          <b-form-group>
            <label for="inline-form-category-name">Name</label>
            <b-input-group>
              <b-input id="inline-form-category-name" class="" placeholder="Document Type Name"
                v-model="documentTypeForEdit.name">
              </b-input>
            </b-input-group>
            <b-input-group class="mt-2">
              <b-form-checkbox toggle v-model="documentTypeForEdit.isArchived" :disabled="documentTypeForEdit.id==null"
                switch>Archive</b-form-checkbox>
            </b-input-group>
          </b-form-group>
        </b-form>
      </div>
      <template v-slot:modal-footer>
        <b-btn variant="light" @click="toggleModal">Close</b-btn>
        <b-btn variant="primary" @click="savedocumentTypeForEdit">Save</b-btn>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DocumentTypes',
  created () {
    this.fields = [
      { key: 'name', label: 'Document Type', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'isArchived', label: 'Archived', sortable: true },
      { key: 'id', label: 'Actions' }]
  },
  components: {
  },
  data () {
    return {
      shouldShowCategoryEditor: false,
      documentTypeForEdit: null,
      modalOpen: false,
      showArchived: false,
      fields: [],
      isBusy: false,
      sortBy: 'name',
      sortDirection: 'asc',
      filter: null,
      sortDesc: true,
      documentTypes: []
    }
  },
  computed: {
    documentTypeTableData () {
      var returnDocumentTypes = {
        fields: this.fields.filter(f => {
          return this.showArchived ? true : f.key !== 'isArchived'
        })
      }
      console.log(
        'Document Type Table Data is: ' +
        JSON.stringify(returnDocumentTypes, null, 2)
      )
      return returnDocumentTypes
    }
  },
  methods: {
    ...mapActions('events', ['getEventTypes', 'getDocumentTypes', 'saveDocumentType']),
    documentTypeProvider (ctx) {
      this.isBusy = true
      console.log(
        'document type table ctx is: ' + JSON.stringify(ctx, null, 2)
      )
      var request = { sortBy: ctx.sortBy, sortDirection: ctx.sortDesc ? 'desc' : 'asc', search: ctx.filter, showArchived: this.showArchived }

      // Must return a promise that resolves to an array of items
      return this.getDocumentTypes(request).then(r => {
        // Pluck the array of items off our axios response
        const items = r.data.documentTypes
        console.log(
          'Returned Document Type Table Data is: ' +
          JSON.stringify(items, null, 2)
        )
        this.isBusy = false
        this.documentTypes = items
        // Must return an array of items or an empty array if an error occurred
        return items || []
      })
    },
    showDocumentTypeModal (id) {
      console.log('DT', id, this.documentTypes)
      if (id !== null) {
        this.documentTypeForEdit = this.documentTypes.find(dt => dt.id === id)
        console.log('ID', id)
      } else {
        this.documentTypeForEdit = Object.assign({name: '', isArchived: false, isSystemType: false})
      }
      this.modalOpen = true
    },
    savedocumentTypeForEdit () {
      if (this.documentTypeForEdit === null || this.documentTypeForEdit.name === null || this.documentTypeForEdit.name.trim() === '') {
        this.$toasted.show('Nothing to save. Name was left blank.', {duration: 4000})
        this.modalOpen = false
      } else {
        if (this.documentTypeForEdit.isSystemType === true) {
          this.$toasted.error('System types cannot be edited', {duration: 4000})
          return new Promise(resolve => { resolve() })
        }
        return this.saveDocumentType(this.documentTypeForEdit).then((result) => {
          this.modalOpen = false
          this.$root.$emit('bv::refresh::table', 'document-types-table')
          this.$toasted.show(this.documentTypeForEdit.name + ' Saved sucessfully', {duration: 4000})
        })
      }
    },
    toggleModal () {
      this.modalOpen = !this.modalOpen
    },
    toggleShowArchived (value) {
      this.$root.$emit('bv::refresh::table', 'document-types-table')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/setup/DocumentTypes.vue